<template>
    <div class="row">
        <template v-for="(abono, index) in abonos">
            <div :key="index + 'a'" class="col-12">
                <div class="card bg-light">
                    <div class="card-body">
                        <strong class="text-primary">ABONO {{ parseInt(index) + 1 }}.</strong>
                        <strong class="text-uppercase">
                            <span v-if="abono.asiento && abono.asiento.zona_nombre">:{{ abono.asiento.zona_nombre }}</span>
                            <span v-if="abono.asiento && abono.asiento.fila">/ FILA: {{ abono.asiento.fila }}</span>
                            <span v-if="abono.asiento && abono.asiento.asiento">/ BUTACA: {{ abono.asiento.asiento }}</span>
                            <span v-if="abono.plaza">  {{ abono.plaza.plazaName }}</span>
                        </strong>
                    </div>
                </div>
            </div>
            <div :key="index  + 'b'" class="col-6">
                <div class="row">
                    <div class="col-12">
                        <span class="h4 text-uppercase"><strong>{{ abono.nombre }} {{ abono.apellidos }}</strong></span>
                    </div>
                    <div class="col-12">
                        <i class="fas fa-id-card"></i> {{ abono.dni }}
                    </div>
                    <div class="col-12">
                        <i class="fas fa-envelope"></i> {{ abono.email }}
                    </div>
                    <div class="col-12">
                        <i class="fas fa-phone"></i> {{ abono.telefono }}
                    </div>
                    <div class="col-12" v-if="urls_imprimir.length > 0">
                        <Button :href="urls_imprimir[index]" target="blank_">IMPRIMIR ABONO</Button>
                    </div>
                </div>
            </div>
            <div :key="index  + 'c'" class="col-6">
                <div class="row">
                    <div class="col-12">
                        <strong>TIPO DE ABONO</strong>
                    </div>
                    <div class="col-12">
                        <span class="h3 text-uppercase"><strong>{{ abono.precio.descripcion }}</strong></span>
                    </div>
                    <template>
                        <div class="col-12">
                            <strong>
                                PRECIO ABONO 
                                <span v-if="abono.descuento_aplicado > 0">
                                    (DESCUENTO DEL 
                                    <span class="text-primary">
                                        {{ abono.descuento_aplicado }}%
                                    </span>
                                    )
                                </span>
                                <span v-else-if="abono.descuento_monedero">
                                    (DESCUENTO DE 
                                    <span class="text-primary">
                                        {{ abono.descuento_monedero | formatear_precio }}
                                    </span>
                                    )
                                </span>
                                <span v-else-if="abono.descuento_integro">
                                    (DESCUENTO DE 
                                    <span class="text-primary">
                                        {{ abono.descuento_integro | formatear_precio }}
                                    </span>
                                    )
                                </span>
                            </strong>
                        </div>
                        <div class="col-12">
                            <span class="h4" v-if="abono.descuento_aplicado > 0 || abono.descuento_monedero || abono.descuento_integro > 0">
                                <strike>
                                    <strong>
                                        {{ abono.precio.precio_total_taquilla | formatear_precio }}
                                    </strong>
                                </strike>
                            </span>
                            <span class="h2 ml-2">
                                <strong v-if="abono.descuento_monedero">
                                    {{ totalConMonedero(abono.precio.precio_total_taquilla, abono.descuento_monedero) | formatear_precio }}
                                </strong>
                                <strong v-if="abono.descuento_integro">
                                    {{ totalConMonedero(abono.precio.precio_total_taquilla, abono.descuento_integro) | formatear_precio }}
                                </strong>
                                <strong v-else>
                                    {{ totalConDescuento(abono.precio.precio_total_taquilla, abono.descuento_aplicado) | formatear_precio }}
                                </strong>
                            </span>
                        </div>
                    </template>
                    <template v-if="abono.plazos">
                        <div class="col-12 mt-3">
                            <strong>PLAZOS:</strong>
                        </div>
                        <div class="col-12">
                            <ul>
                                <template v-for="(plazo, key) in abono.plazos_pendientes">
                                    <li :key="key">
                                        <template v-if="plazo.gastos_internos == 0">
                                            Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe + plazo.gastos  | formatear_precio }}
                                        </template>
                                        <template v-else>
                                            Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe  | formatear_precio }}
                                        </template>                                            
                                    </li>
                                </template>                                
                            </ul>
                        </div>
                    </template>                    
                </div>
            </div>
        </template>
        <div class="col-12">
            <strong>TOTAL: <span class="h1"><strong>{{ total | formatear_precio }}</strong></span></strong>
        </div>
        <div class="col-12">
            <strong>FORMA DE PAGO: <span class="h3"><strong>{{ Array.isArray(datos_compra.metodo_pago) ? datos_compra.metodo_pago.map(i => i.nombre).join(', ') : datos_compra.metodo_pago.nombre }}</strong></span></strong>
        </div>
    </div>
</template>

<script>
export default {
    props: ['abonos', 'datos_compra', 'urls_imprimir'],
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        total() {
            var total = 0;

            for(var i in this.abonos) {
                if(this.abonos[i].plazos) {
                    var precio = this.abonos[i].plazos_pendientes[0].importe;

                    if(! this.abonos[i].plazos_pendientes[0].gastos_internos) {
                        precio = precio + this.abonos[i].plazos_pendientes[0].gastos;
                    }

                    total = total + precio;

                } else {
                    var precio_total_taquilla = this.abonos[i].precio.precio_total_taquilla;
                    var descuento = this.abonos[i].descuento_aplicado;

                    var cantidad_descuento = (descuento / 100) * precio_total_taquilla;

                    var total_con_descuento = precio_total_taquilla - cantidad_descuento;

                    total = total + total_con_descuento;
                }
                
                if(this.abonos[i].descuento_monedero) {
                    total = total - this.abonos[i].descuento_monedero;
                }

                if(this.abonos[i].descuento_integro) {
                    total = total - this.abonos[i].descuento_integro;
                }
            }

            this.$emit('setTotal', total);

            return total;
        }
    },
    methods: {
        actualizado() {
            this.$emit('actualizado');
        },
        totalConDescuento(precio, descuento) {
            var desc = (descuento / 100) * precio;
            return precio - desc;
        },
        totalConMonedero(precio, monedero) {
            return precio - monedero;
        }
    },
}
</script>
